import ManageImageGallery from './manage-image-gallery'
export default ManageImageGallery
